<template>
  <div class="dashboard">
    <template-metadata-dialog :dialog.sync="dialog" v-if="dialog"></template-metadata-dialog>

    <v-toolbar flat class="secondary lighten-2 elevation-1" dark>
      <v-toolbar-title>{{ $t('template_matrix_componenttitle') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- TODO <v-btn tile @click="drawerRightVisible = !drawerRightVisible"><v-icon color="primary">filter_list</v-icon></v-btn>-->
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="audittemplates"
      hide-actions
      class="elevation-1"
      :pagination="listConfigPaginationDataTable"
      id="paginationstart"
    >
      <template slot="items" slot-scope="props">
        <td @click="$router.push('/templates/' + props.item.id)">{{ props.item.name }}</td>
        <td @click="$router.push('/templates/' + props.item.id)" class="text-xs-right">
          <SnippetStandard :standard="props.item.standard" />
        </td>
        <td
          @click="$router.push('/templates/' + props.item.id)"
          class="text-xs-right"
        >{{ props.item.type }}</td>
        <td
          @click="$router.push('/templates/' + props.item.id)"
          class="text-xs-right"
        >{{ props.item.audited_by }}</td>
        <td @click="$router.push('/templates/' + props.item.id)" class="text-xs-right">
          <snippet-chips :currentItems="props.item.scope"></snippet-chips>
        </td>
        <td
          @click="$router.push('/templates/' + props.item.id)"
          class="text-xs-right"
        >{{ props.item.created_date | formatDates($t('today_text')) | arrayToString(', ') }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.item.id)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data">{{ $t('template_matrix_nodata') }}</template>
    </v-data-table>
    <PaginationControl
      v-if="listConfigPaginationRequired"
      :page-sizes="listConfigPageSizes"
      :length="listConfigPageCount"
      @change="listConfigOnPaginationChange"
    />
    <v-btn fab bottom right color="pink" dark fixed @click="createItem()">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<i18n>
  {
    "de": {
      "template_matrix_componenttitle" : "Auditvorlagen",
      "template_matrix_title" : "Name",
      "template_matrix_standard" : "Standard",
      "template_matrix_type" : "Typ",
      "template_matrix_art" : "Art",
      "template_matrix_scope" : "Bereich",
      "template_matrix_created" : "Angelegt",
      "template_matrix_actions" : "Aktionen",
      "template_matrix_nodata" : "Keine Ergebnisse",
      "today_text" : "heute"
    },
    "en": {
      "template_matrix_componenttitle" : "Audittemplates",
      "template_matrix_title" : "Name",
      "template_matrix_standard" : "Standard",
      "template_matrix_type" : "Type",
      "template_matrix_art" : "Art",
      "template_matrix_scope" : "Scope",
      "template_matrix_created" : "Created by",
      "template_matrix_actions" : "Actions",
      "today_text" : "today"
    }
  }
</i18n>

<script>
import TemplateMetadataDialog from "@/components/dialogs/TemplateMetadataDialog.vue";
import SnippetChips from "@/components/snippets/Chips.vue";
import PaginationControl from "@/components/controls/PaginationControl";

import FormattingMixin from "@/components/mixins/FormattingMixin";
import ListConfigurationMixin from "@/components/mixins/ListConfigurationMixin";

import SnippetStandard from "@/components/snippets/SnippetStandard";

import uuid from "uuid";

import { mapGetters, mapActions } from "vuex";
import { api } from "@/store/modules/templates";

export default {
  name: "TemplateMatrix",
  components: {
    TemplateMetadataDialog,
    SnippetChips,
    PaginationControl,
    SnippetStandard
  },
  data() {
    return {
      drawerRightVisible: false,
      today: new Date().toISOString().slice(0, 10),
      isUpdate: false,
      date: null,
      dialog: false,
      headers: [
        {
          text: this.$i18n.t("template_matrix_title"),
          align: "left",
          sortable: true,
          value: "name"
        },
        { text: this.$i18n.t("template_matrix_standard"), value: "standard" },
        { text: this.$i18n.t("template_matrix_type"), value: "type" },
        { text: this.$i18n.t("template_matrix_art"), value: "audited_by" },
        { text: this.$i18n.t("template_matrix_scope"), value: "scope" },
        {
          text: this.$i18n.t("template_matrix_created"),
          value: "created_date"
        },
        {
          text: this.$i18n.t("template_matrix_actions"),
          value: "name",
          sortable: false
        }
      ],
      editedItem: {
        id: uuid.v4(),
        name: "Fragenliste",
        standard: "ISO9001",
        type: "Prozessaudit",
        audited_by: "Intern",
        scope: "",
        created_date: "2018-08-08",
        audit_items: {}
      },
      defaultItem: {
        id: uuid.v4(),
        name: "Default",
        standard: "ISO9001",
        type: "",
        audited_by: "Intern",
        scope: "",
        auditor: "",
        planning_date: "",
        auditing_date: "",
        audit_items: {}
      }
    };
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.loadedAudits]),
    audittemplates() {
      return this.loadedAudits;
    },

    // Overwrites from ListConfigurationMixin
    listConfigConfigKey: () => "templatematrix",
    listConfigTotalItemCount() {
      return this.audittemplates.length;
    }
  },
  mixins: [FormattingMixin, ListConfigurationMixin],
  methods: {
    ...mapActions(api.namespace, [
      api.actions.setDialogAction,
      api.actions.setDialogItem,
      api.actions.setAuditId,
      api.actions.deleteAudit
    ]),
    editItem(template_id) {
      const template = this.audittemplates.find(
        template => template.id === template_id
      );
      this.setDialogAction("update");
      this.setAuditId(template.id);
      this.setDialogItem(template);
      this.dialog = true;
    },
    createItem() {
      this.setDialogAction("create");
      this.setDialogItem({
        created_by: this.$user.displayName(),
        created_date: this.today
      });
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.audittemplates.indexOf(item);
      const payload = {
        audit_id: this.audittemplates[index].id,
        audit_index: index,
        activity: {
          id: uuid.v4(),
          avatar: this.$user.avatar() || "",
          actor: this.$user.id(),
          verb:
            this.$user.displayName() +
            " hat das Template " +
            this.audittemplates[index].name +
            " gelöscht.",
          object: this.audittemplates[index].id,
          //object_url: "/templates/" + this.audittemplates[index].id,
          timestamp: new Date()
        }
      };

      confirm("Are you sure you want to delete this item?") &&
        //this.$store.dispatch("audits/deleteAudit", payload);
        this.deleteAudit(payload);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    }
  }
};
</script>
